import { render } from "./DocumentUploadAsFormField.vue?vue&type=template&id=b2cf2a16"
import script from "./DocumentUploadAsFormField.vue?vue&type=script&lang=js"
export * from "./DocumentUploadAsFormField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__